import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Award } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function CertificateDetailsForm({ user, token, onSaved, colors }) {
  const [form, setForm] = useState({ state: user?.state || "", license_number: user?.license_number || "", agd_number: user?.agd_number || "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSave = async (e) => {
    e.preventDefault();
    if (!form.state.trim() || !form.license_number.trim()) {
      toast.error("State and license number are required for your CE certificate");
      return;
    }
    setSaving(true);
    try {
      const body = new URLSearchParams(form);
      const res = await axios.put(`${API}/users/profile`, body, { headers: { Authorization: `Bearer ${token}` } });
      onSaved(res.data);
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to save details");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSave} className="space-y-4" data-testid="certificate-details-form">
      <div className="flex items-start gap-3 p-3 rounded-lg" style={{ background: colors.accent + "14", border: `1px solid ${colors.accent}55` }}>
        <Award className="w-5 h-5 flex-shrink-0 mt-0.5" style={{ color: colors.accent }} />
        <p className="text-sm" style={{ color: colors.heading }}>
          Your CE certificate must show your <strong>state and dental license number</strong>. Please add them before continuing.
        </p>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label style={{ color: colors.heading }}>State *</Label>
          <Input value={form.state} onChange={set("state")} placeholder="TN" maxLength={2} data-testid="cert-details-state" />
        </div>
        <div>
          <Label style={{ color: colors.heading }}>License # *</Label>
          <Input value={form.license_number} onChange={set("license_number")} placeholder="12345" data-testid="cert-details-license" />
        </div>
      </div>
      <div>
        <Label style={{ color: colors.heading }}>AGD member # (optional)</Label>
        <Input value={form.agd_number} onChange={set("agd_number")} placeholder="Leave blank if not an AGD member" data-testid="cert-details-agd" />
      </div>
      <Button type="submit" disabled={saving} className="w-full py-5 text-base font-semibold text-white" style={{ background: colors.accent }} data-testid="cert-details-save">
        {saving ? "Saving..." : "Save & Continue to Survey"}
      </Button>
    </form>
  );
}
